"use strict";
angular.module("smsManageServiceModule", [
    "createSMSModule", //新建短信配置
]).
factory("smsManageService", ["$modal", "$q", function($modal, $q) {
    return {
        /**
         * [createProduct description] 新增/编辑短信配置
         * @param {[boolean]} [isCreate] [description] 是否是新增  true为新增 false为编辑
         * @param {[string]} [id] [description] 用户ID
         */
        createSMS: function(isCreate, id) {
            var deffer = $q.defer();
            var modalInstance = $modal.open({
                templateUrl: "./main/backstage/loginPageMangement/smsManage/service/createSMS/createSMS_tpl.html",
                windowClass: 'createsms createUser backstageModalHeader',
                backdrop: false,
                controller: "createSMSCtrl",
                resolve: {
                    id: function() {
                        return id;
                    },
                    isCreate: function() {
                        return isCreate;
                    }
                }
            });
            modalInstance.result.then(function(result) {
                deffer.resolve(result);
            });
            return deffer.promise;
        }
    };
}]);